export const PUBLISH_DRAFT_SUCCESS_FLAG_ID = 'publishDraftSuccess';
export const DEFER_SPACE_PUBLISH_DRAFT_SUCCESS_FLAG_ID = 'deferSpacePublishDraftSuccess';
export const LINK_PAGE_SUCCESS_FLAG_ID = 'linkPageSuccess';
export const PUBLISH_DRAFT_ERROR_FLAG_ID = 'publishDraftFailed';
export const LINK_PAGE_FAILED_FLAG_ID = 'linkPageFailed';
